import React, { useContext } from 'react'

import PluginContext from './PluginContext'
import hoistHocStatic from './utils/hoistHocStatic'

const withPlugin = (Component, options = {}, staticMethods) => {
  const displayName = `withPlugin(${Component.displayName || Component.name})`
  const WrappedComponent = props => {
    const plugins = useContext(PluginContext)

    return (
      <Component {...plugins} {...props}></Component>
    )
  }

  hoistHocStatic(WrappedComponent, Component, staticMethods)
  WrappedComponent.displayName = displayName
  return WrappedComponent
}

export default withPlugin